// @flow

import styled from 'styled-components';
import { REGULAR } from '../../../../helpers/fontWeight';
import type { Theme } from '../../../../types';

const Payment = styled<any, Theme>('span')`
  display: block;
  font-size: ${props => props.theme.carblock.payment.fontSize};
  font-weight: ${REGULAR};
  line-height: ${props => props.theme.carblock.payment.lineHeight};
  max-width: ${props => props.theme.carblock.payment.width};
  color: ${props => props.theme.carblock.color};

  &::first-line {
    font-size: ${props => props.theme.carblock.payment.firstLineFontSize};
  }
`;

export default Payment;
